import { widgetMixin } from './widgetMixin'
import { removeTime, setEndTime } from '@/utils/date'
import subWeeks from 'date-fns/subWeeks'
import subMonths from 'date-fns/subMonths'
import addDays from 'date-fns/addDays'

export const shortScopeMixin = function (autoReload = false) {
  return {

    data() {
      return {
        scopes: {
          today: {
            description: 'Today',
            from: null,
            to: null
          },
          week: {
            description: 'Past Week',
            from: null,
            to: null
          },
          month: {
            description: 'Past Month',
            from: null,
            to: null
          }
        },
        scopeForm: {
          scope: 'today',
          from: null,
          to: null
        }
      }
    },
    computed: {
      selectedScope() {
        if (this.scopeForm.scope) {
          return this.scopes[this.scopeForm.scope]
        }
        return {}
      }
    },
    methods: {
      updateTimeNow() {
        this.timeNow = new Date()

        // Init the dates for the scopes
        this.scopes.today.from = removeTime(this.timeNow)
        this.scopes.today.to = setEndTime(this.timeNow)

        this.scopes.week.from = removeTime(addDays(subWeeks(this.timeNow, 1), 1))
        this.scopes.week.to = setEndTime(this.timeNow)

        this.scopes.month.from = removeTime(addDays(subMonths(this.timeNow, 1), 1))
        this.scopes.month.to = setEndTime(this.timeNow)
      },
      doSelectScope(scope, reload = true) {
        if (this.scopes[scope]) {
          const option = this.scopes[scope]
          this.scopeForm.scope = scope
          this.scopeForm.from = option.from
          this.scopeForm.to = option.to
          if (reload) {
            this.doReload()
          }
        }
      }
    },
    mixins: [
      widgetMixin(autoReload)
    ]
  }
}
